import React, { useState, useEffect } from "react";
import { db } from "../firebase/firebase-config";
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc } from "firebase/firestore";
import {setPageTitle} from "../store/themeConfigSlice";
import {useDispatch} from "react-redux";

interface SyariahIntervention {
    id?: string;
    range: string;
    intervention: string;
    [key: string]: any; // Tambahkan ini untuk menghindari error TS2345
}


const SyariahInterventionPage: React.FC = () => {
    const [interventions, setInterventions] = useState<SyariahIntervention[]>([]);
    const [formData, setFormData] = useState<SyariahIntervention>({ range: "", intervention: "" });
    const [editingId, setEditingId] = useState<string | null>(null);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setPageTitle("Syariah Intervention"));
    }, [dispatch]);


    // Ambil data dari Firestore
    useEffect(() => {
        const fetchInterventions = async () => {
            const querySnapshot = await getDocs(collection(db, "syariah_interventions"));
            const interventionsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as SyariahIntervention));
            setInterventions(interventionsData);
        };
        fetchInterventions();
    }, []);

    // Handle perubahan input form
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [event.target.name]: event.target.value });
    };

    // Tambah atau update intervensi
    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();

        try {
            if (editingId) {
                // Update data
                await updateDoc(doc(db, "syariah_interventions", editingId), formData);
                alert("Data updated successfully!");
            } else {
                // Tambah data baru
                await addDoc(collection(db, "syariah_interventions"), formData);
                alert("Data added successfully!");
            }
            window.location.reload(); // Refresh halaman setelah operasi
        } catch (error) {
            console.error("Error saving document:", error);
        }
    };

    // Hapus intervensi
    const handleDelete = async (id: string) => {
        if (!window.confirm("Are you sure you want to delete this entry?")) return;
        try {
            await deleteDoc(doc(db, "syariah_interventions", id));
            alert("Data deleted successfully!");
            window.location.reload(); // Refresh halaman setelah operasi
        } catch (error) {
            console.error("Error deleting document:", error);
        }
    };

    // Edit intervensi
    const handleEdit = (intervention: SyariahIntervention) => {
        setEditingId(intervention.id || null);
        setFormData({ range: intervention.range, intervention: intervention.intervention });
    };

    return (
        <div className="p-6">
            {/*<h2 className="text-xl font-bold mb-4">Manage Syariah Interventions</h2>*/}
            <h1 className="text-2xl font-bold mb-4">Manage Syariah Interventions</h1>

            {/* Form Input */}
            <form onSubmit={handleSubmit} className="mb-6">
                <div className="mb-4">
                    <label className="block font-semibold">Pain Level Range:</label>
                    <input type="text" name="range" value={formData.range} onChange={handleChange} className="border p-2 w-full" placeholder="e.g., 1-3" required />
                </div>
                <div className="mb-4">
                    <label className="block font-semibold">Intervention:</label>
                    <input type="text" name="intervention" value={formData.intervention} onChange={handleChange} className="border p-2 w-full" placeholder="Enter intervention" required />
                </div>
                <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
                    {editingId ? "Update" : "Add"}
                </button>
            </form>

            {/* List Data */}
            <table className="w-full border-collapse border border-gray-300">
                <thead>
                <tr className="bg-gray-200">
                    <th className="border p-2">Pain Level Range</th>
                    <th className="border p-2">Intervention</th>
                    <th className="border p-2">Actions</th>
                </tr>
                </thead>
                <tbody>
                {interventions.map((item) => (
                    <tr key={item.id} className="border">
                        <td className="border p-2">{item.range}</td>
                        <td className="border p-2">{item.intervention}</td>
                        <td className="border p-2">
                            <button onClick={() => handleEdit(item)} className="bg-yellow-500 text-white px-3 py-1 mr-2">Edit</button>
                            <button onClick={() => handleDelete(item.id!)} className="bg-red-500 text-white px-3 py-1">Delete</button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default SyariahInterventionPage;
